import React, { createContext, useContext, ReactNode } from 'react';
import TimchehLoader from './TimchehLoader';
import useTimchehLoader from '../hooks/useTmchehLoader';

interface timchehLoaderContextType {
  showLoader: (options?: {
    message?: string;
    size?: 'small' | 'medium' | 'large';
    fullScreen?: boolean;
  }) => void;
  hideLoader: () => void;
  updateLoader: (options: {
    message?: string;
    size?: 'small' | 'medium' | 'large';
    fullScreen?: boolean;
  }) => void;
  isVisible: boolean;
}

const timchehLoaderContext = createContext<timchehLoaderContextType | undefined>(undefined);

interface TimchehLoaderProvider {
  children: ReactNode;
}

export const TimchehLoaderProvider: React.FC<TimchehLoaderProvider> = ({ children }) => {
  const { loaderState, showLoader, hideLoader, updateLoader, isVisible } = useTimchehLoader();

  return (
    <timchehLoaderContext.Provider value={{ showLoader, hideLoader, updateLoader, isVisible }}>
      {children}
      {loaderState.isVisible && (
        <TimchehLoader
          message={loaderState.message}
          size={loaderState.size}
          fullScreen={loaderState.fullScreen}
        />
      )}
    </timchehLoaderContext.Provider>
  );
};

export const useGlobalLoader = (): timchehLoaderContextType => {
  const context = useContext(timchehLoaderContext);
  if (context === undefined) {
    throw new Error('useGlobalLoader must be used within a TimchehLoaderProvider');
  }
  return context;
};

export default TimchehLoaderProvider; 